/**
 * Ids the shell's parts use to point at each other.
 *
 * Their own module rather than `RootLayout`: the skip link lives in the header,
 * the header is imported BY the layout, and importing the layout back from a
 * shell component would close a cycle.
 */

/** The `<main>` element the skip link jumps to. */
export const MAIN_CONTENT_ID = "main-content";
